var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// in target lib -> webpack -> 'global': 'window' (define plugin) ID5 authors using "global" instead of "window"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ID5 from '@id5io/id5-api.js';
import { IDENTITIES_KEYS, } from '../../types';
import { EVENT_NAME, TIMEOUT } from '../consts';
import { isTopLevel } from '../frames';
import { browser } from '../utils';
import { getLoginObject } from './login';
let _instance = null;
/**
 * Gradual rollout (only for some services) -> TEMPORARY
 */
export const _isWhitelistedService = () => {
    var _a, _b, _c, _d;
    const services = ['horoskopy.cz', 'novinky.cz', 'prozeny.cz', 'super.cz'];
    // debug / testing purposes
    if ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.includes('allow_hostname_for_id5=1')) {
        return true;
    }
    return services.includes((_d = (_c = window.location) === null || _c === void 0 ? void 0 : _c.hostname) === null || _d === void 0 ? void 0 : _d.replace(/^www\./, ''));
};
/**
 * Is INTERNAL service? Lets hook to CMP data submited by SSSP
 * Is WHITELISTED service? Go ahead right away
 */
export const _isValidService = () => {
    return new Promise((resolve) => {
        // TODO: consider SUL metadata as well
        // whitelist
        if (_isWhitelistedService()) {
            resolve(true);
        }
        else {
            resolve(false);
        }
        // internal -> uncoment after whitelist removal (including tests)
        // const cmpData = window.sssp?.conf?.cmpData || window.scmp_sspServerData || null;
        // if (cmpData) {
        //   resolve(cmpData.internalPartner);
        // } else {
        //   const timeout = window.setTimeout(() => {
        //     window.removeEventListener('cmpdatareceived', handler);
        //     resolve(false);
        //   }, TIMEOUT);
        //   const handler = (e: Event): void => {
        //     window.clearTimeout(timeout);
        //     window.removeEventListener('cmpdatareceived', handler);
        //     resolve(!!(e as CustomEvent).detail?.internalPartner);
        //   };
        //   window.addEventListener('cmpdatareceived', handler);
        // }
    });
};
/**
 * Third party hating browsers like FF, Safari, ...
 */
export const _isValidBrowser = () => browser.isSafari() || browser.isFirefox();
/**
 * Run whole ID5 flow only in some environments (one time check at beginning)
 */
export const _isValidEnvironment = () => __awaiter(void 0, void 0, void 0, function* () {
    const serviceOk = yield _isValidService();
    const browserOk = _isValidBrowser();
    if (!isTopLevel || !browserOk || !serviceOk) {
        return false;
    }
    return true;
});
/**
 * Create instance (singleton with SEZNAM specific partnerId)
 */
export const _getInstance = (handler) => {
    if (!_instance) {
        _instance = ID5.init({ partnerId: 265, cmpApi: 'iab' });
        _instance.onAvailable(handler, TIMEOUT);
        _instance.onUpdate(handler, TIMEOUT);
    }
};
/**
 * We can generate / fetch ID5 and store it in IS only in "not logged" + "with consent" (used multiple times during LOGIN lifecycle updates)
 */
export const _canPropagateID5ToIS = (getter, awaiter) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const login = (yield awaiter(IDENTITIES_KEYS.login));
    const consent = getter(IDENTITIES_KEYS.consent);
    return (
    // no login or login is "forget"
    (!(login === null || login === void 0 ? void 0 : login.value) || !getLoginObject() || login.value.state === 'forget') &&
        (
        // consented
        (_a = consent === null || consent === void 0 ? void 0 : consent.value) === null || _a === void 0 ? void 0 : _a.purposeOne));
});
/**
 * Fetch ID5 identificator (if not locally stored -> make api call)
 */
export const fetchId5 = (updater, getter, awaiter) => __awaiter(void 0, void 0, void 0, function* () {
    // hard stop for some environments
    if (!(yield _isValidEnvironment())) {
        return;
    }
    // create instance + fetch (if "login, consent, ..." conditions met)
    const handler = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!(yield _canPropagateID5ToIS(getter, awaiter))) {
            return;
        }
        const ID5handler = (status) => __awaiter(void 0, void 0, void 0, function* () {
            // anxious check (maybe login, consent, ... conditions changed in meantime)
            if (!(yield _canPropagateID5ToIS(getter, awaiter))) {
                return;
            }
            const newId5 = status.getUserId();
            if (newId5) {
                updater({ id5: { value: newId5 } });
            }
        });
        _getInstance(ID5handler);
    });
    handler();
    // listen for login changes
    window.addEventListener(EVENT_NAME, ((e) => {
        const { changes } = e.detail;
        if (changes.includes(IDENTITIES_KEYS.login) || changes.includes(IDENTITIES_KEYS.consent)) {
            handler();
        }
    }));
});
